import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sort",
  "use": "icon-sort-usage",
  "viewBox": "0 0 25 25",
  "content": "<symbol viewBox=\"0 0 25 25\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-sort\">\n<path d=\"M12.0016 6.50098L16.0022 11.5017H8.00098L12.0016 6.50098Z\" fill=\"#323232\" />\n<path d=\"M12.0016 18.5028L8.00098 13.502L16.0022 13.502L12.0016 18.5028Z\" fill=\"#323232\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol